export default "__VITE_ASSET__5c4992d2__"